import axios from "axios";

export default {
  async razCampagne() {
    await axios.post(
      process.env.VUE_APP_BACKEND_API_URL + "/api/admin/razCampagne"
    );
  }
};
